import { render, staticRenderFns } from "./AdvertisersSelect.vue?vue&type=template&id=5796b7ab&scoped=true"
import script from "./AdvertisersSelect.vue?vue&type=script&lang=js"
export * from "./AdvertisersSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5796b7ab",
  null
  
)

export default component.exports